// init hotjar-fallback, hotjar is loaded via the GoogleTagManager
const defaultHotJar = (...args) => (window.hj.q = window.hj.q || []).push(args);

export const initHotjarFallback = () =>
  (window.hj = window.hj || defaultHotJar);

export const hjTrigger = val => window.hj('trigger', val);
